import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import LoginCard from './LoginCard';
import { handleLogin } from './LoginService';
import { Container } from './styles';

const initialForm = {
  user: '',
  password: '',
};

function Login() {
  const [form, setForm] = useState(initialForm);
  const [loading, setLoading] = useState(false);
  const [togglePassword, setTogglePassword] = useState(false);

  const history = useHistory();

  async function handleSubmit(event) {
    const login = {
      login: form.user.toUpperCase(),
      senha: form.password,
      idModulo: 0,
    };
    await handleLogin(event, setLoading, login);
    history.push('/');
  }

  return (
    <Container>
      <LoginCard
        form={form}
        setForm={setForm}
        handleLogin={handleSubmit}
        loading={loading}
        setTogglePassword={setTogglePassword}
        togglePassword={togglePassword}
      />
    </Container>
  );
}

export default Login;
